// extracted by mini-css-extract-plugin
export var body = "_cm-0";
export var sectionHeader = "_cm-4";
export var shortcutColumns = "_cm-2";
export var shortcutList = "_cm-1";
export var shortcutSection = "_cm-3";